var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 25,
    viewBox: "0 0 10 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_183_2",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 25,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 10,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59668 16.3242H5.43555C7.264 16.6142 8.66211 18.1974 8.66211 20.1074C8.66197 22.223 6.94668 23.9384 4.83105 23.9385C2.71537 23.9385 1.00014 22.2231 1 20.1074C1 18.1977 2.39749 16.6145 4.22559 16.3242H4.06445V1H5.59668V16.3242Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59668 16.3242H5.43555C7.264 16.6142 8.66211 18.1974 8.66211 20.1074C8.66197 22.223 6.94668 23.9384 4.83105 23.9385C2.71537 23.9385 1.00014 22.2231 1 20.1074C1 18.1977 2.39749 16.6145 4.22559 16.3242H4.06445V1H5.59668V16.3242Z",
    fill: "#003032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59668 16.3242V17.3242H6.59668V16.3242H5.59668ZM5.43555 16.3242V15.3242L5.27894 17.3119L5.43555 16.3242ZM8.66211 20.1074L9.66211 20.1075V20.1074H8.66211ZM4.83105 23.9385V24.9385H4.83108L4.83105 23.9385ZM1 20.1074H0V20.1075L1 20.1074ZM4.22559 16.3242L4.38239 17.3118L4.22559 15.3242V16.3242ZM4.06445 16.3242H3.06445V17.3242H4.06445V16.3242ZM4.06445 1V0H3.06445V1H4.06445ZM5.59668 1H6.59668V0H5.59668V1ZM5.59668 16.3242V15.3242H5.43555V16.3242V17.3242H5.59668V16.3242ZM5.43555 16.3242L5.27894 17.3119C6.62948 17.526 7.66211 18.6971 7.66211 20.1074H8.66211H9.66211C9.66211 17.6977 7.89851 15.7023 5.59216 15.3366L5.43555 16.3242ZM8.66211 20.1074L7.66211 20.1074C7.66201 21.6708 6.39436 22.9384 4.83102 22.9385L4.83105 23.9385L4.83108 24.9385C7.49901 24.9384 9.66194 22.7753 9.66211 20.1075L8.66211 20.1074ZM4.83105 23.9385V22.9385C3.26772 22.9385 2.0001 21.6708 2 20.1074L1 20.1074L0 20.1075C0.000173867 22.7753 2.16302 24.9385 4.83105 24.9385V23.9385ZM1 20.1074H2C2 18.6972 3.03224 17.5262 4.38239 17.3118L4.22559 16.3242L4.06879 15.3366C1.76275 15.7027 0 17.6981 0 20.1074H1ZM4.22559 16.3242V15.3242H4.06445V16.3242V17.3242H4.22559V16.3242ZM4.06445 16.3242H5.06445V1H4.06445H3.06445V16.3242H4.06445ZM4.06445 1V2H5.59668V1V0H4.06445V1ZM5.59668 1H4.59668V16.3242H5.59668H6.59668V1H5.59668Z",
    fill: "white",
    mask: "url(#path-1-outside-1_183_2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.ac0540eb4bc96a3e7a2deda7530a9342.svg";
export { ForwardRef as ReactComponent };